// components/AboutPreview.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';

const AboutPreview = () => {
  return (
    <div className="py-4">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="order-2 lg:order-1">
            
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2 mb-4 text-left">
              Leading Pharmaceutical Dealership in Gondia
            </h2>
            <p className="text-gray-600 mb-4 leading-relaxed text-left">
              Located at Kk Complex, At-Thana, Amgaon, K.K. Pharmaceuticals has been serving the healthcare needs of Gondia and surrounding regions with dedication and integrity.
            </p>
            <ul className="space-y-2 mb-6">
              {['Quality assured products from trusted manufacturers', 'Strong distribution network across Maharashtra', 'Experienced team of pharmaceutical professionals'].map((item, index) => (
                <li key={index} className="flex items-center space-x-2">
                  <CheckCircle size={20} className="text-primary" />
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            <Link 
              to="/about" 
              className="inline-flex items-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-dark transition duration-300"
            >
              <span>Learn More About Us</span>
              <ArrowRight size={18} />
            </Link>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80" 
                alt="Pharmacy Store" 
                className="rounded-xl shadow-lg w-full h-[320px] object-cover"
              />
              <div className="absolute -bottom-5 -right-5 bg-primary/10 rounded-xl p-4 hidden md:block">
                <div className="bg-white rounded-lg px-6 py-3 shadow-md text-center">
                  <p className="text-2xl font-bold text-primary">10+</p>
                  <p className="text-xs text-gray-500">Years of Excellence</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPreview;